import { render } from "./DisplayModal.vue?vue&type=template&id=5b0d2154"
import script from "./DisplayModal.vue?vue&type=script&lang=js"
export * from "./DisplayModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__